/* global angular, $ */
angular.module('ua5App.index.about')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('index.about', {
            url: 'about',
            templateUrl: 'states/index.about/index.about.html',
            controller: 'AboutCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .run(['$rootScope', '$state', function($rootScope, $state) {
        // Redirect users to artists list when just going to list
        $rootScope.$on('$stateChangeSuccess', function(e, toState) {
            if (toState.url === 'about') {
                $state.go('index.about.exhibition');
            }
        });
    }])
    .controller('AboutCtrl', [function() {

    }])
    .directive('aboutContainer', [function() {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $scope.$on('$stateChangeSuccess', function(e, toState) {
                    if (toState.name.indexOf('about') !== -1) {
                        $($element).scrollTop(0);
                    }
                });
            }
        };
    }])
;
